// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__23mC6","info":"PatientInfo_info__3RcxZ"};